/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DistributeOnboardingCandidateRequestBody,
  DistributeOnboardingCandidateRequestBody$Outbound,
  DistributeOnboardingCandidateRequestBody$outboundSchema,
} from "../components/distributeonboardingcandidaterequestbody.js";

export type RepairPlatformMCPOnboardingPublicationSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RepairPlatformMCPOnboardingPublicationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  distributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody;
};

/** @internal */
export type RepairPlatformMCPOnboardingPublicationSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RepairPlatformMCPOnboardingPublicationSecurity$outboundSchema:
  z.ZodMiniType<
    RepairPlatformMCPOnboardingPublicationSecurity$Outbound,
    RepairPlatformMCPOnboardingPublicationSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function repairPlatformMCPOnboardingPublicationSecurityToJSON(
  repairPlatformMCPOnboardingPublicationSecurity:
    RepairPlatformMCPOnboardingPublicationSecurity,
): string {
  return JSON.stringify(
    RepairPlatformMCPOnboardingPublicationSecurity$outboundSchema.parse(
      repairPlatformMCPOnboardingPublicationSecurity,
    ),
  );
}

/** @internal */
export type RepairPlatformMCPOnboardingPublicationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DistributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody$Outbound;
};

/** @internal */
export const RepairPlatformMCPOnboardingPublicationRequest$outboundSchema:
  z.ZodMiniType<
    RepairPlatformMCPOnboardingPublicationRequest$Outbound,
    RepairPlatformMCPOnboardingPublicationRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      distributeOnboardingCandidateRequestBody:
        DistributeOnboardingCandidateRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        distributeOnboardingCandidateRequestBody:
          "DistributeOnboardingCandidateRequestBody",
      });
    }),
  );

export function repairPlatformMCPOnboardingPublicationRequestToJSON(
  repairPlatformMCPOnboardingPublicationRequest:
    RepairPlatformMCPOnboardingPublicationRequest,
): string {
  return JSON.stringify(
    RepairPlatformMCPOnboardingPublicationRequest$outboundSchema.parse(
      repairPlatformMCPOnboardingPublicationRequest,
    ),
  );
}
